require('./insuranceMortgageDetail.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKMessage } = require('commonsComponents/OKMessage');

class InsuranceMortgageDetail extends React.Component {
    render() {
        const { mortgage } = this.props;

        return (
            <OKSectionBox
                className="insurance-mortgage-detail insurance-request-product-detail-description-ok-section-bottom">
                <article>
                    <OKBoxTitle
                        value={formatText('insuranceConsultiveProductDetails-insuranceMortgageDetailsTitle')}
                    />
                </article>
                <div className="insurance-mortgage-detail__content">
                    <div className="insurance-mortgage-detail__content-text">
                        {formatText('insuranceConsultiveProductDetails-insuranceMortgageDetailsSubtitle')}
                    </div>
                    <i className="insurance-mortgage-detail__content-icon icon rebrand-mortgages"/>
                    <div className="insurance-mortgage-detail__content-name">
                        {mortgage.title}
                    </div>
                    <div className="insurance-mortgage-detail__content-link">
                        <Link to={mortgage.link} className="insurances-list-card-item__link">
                            <FormattedText
                                className="insurances-list-card-item__link-text"
                                value="insuranceLanding-mortgageLinkInsurance"
                            />
                        </Link>
                    </div>
                </div>
                <div className="insurance-mortgage-detail__message">
                    <OKMessage
                        type="informative"
                    >
                        <FormattedText value={'insuranceConsultiveProductDetails-insuranceMortgageDetailAlert'}/>
                    </OKMessage>
                </div>
            </OKSectionBox>
        );
    }
}

InsuranceMortgageDetail.propTypes = {
  mortgage: PropTypes.object.isRequired
}

module.exports = InsuranceMortgageDetail;
